import {
  IStatus,
  IShipmentInfo,
  IShipperTrackingSegment,
  ITrackingStatus,
  RATE_TYPES,
  USER_ROLES,
  TCarrierStatus,
} from 'types'
import { INextStop, IUserProfileDetails, IDriverLocation } from 'types/Location'

export enum USER_TYPES {
  admin = 'admin',
  dispatcher = 'dispatcher',
  driver = 'driver',
  ownerOperator = 'owner_operator',
  shipper = 'shipper',
}

export enum USER_DRIVER_TYPES {
  driver = 'driver',
  ownerOperator = 'owner_operator',
}

export enum USER_CARRIER_TYPES {
  dispatcher = 'dispatcher',
  driver = 'driver',
  ownerOperator = 'owner_operator',
}

export enum USER_STATES {
  Approved = 'Approved',
  Pending = 'Pending',
  Deleted = 'Deleted',
}

export type TUserSources = 'carrier' | 'shipper' | 'marketplace'

export interface IOrgDetails {
  name: string
  id: number
  mcNumber: number
  dotNumber: number
  type: 'carrier' | 'shipper'
}

export interface IChildUser {
  id: string
  applicationId: string
  applicationType: 'ShipperApplication' | 'CarrierApplication'
  companyApplicationState?: TCarrierStatus
  companyId: string
  companyName: string
  companyMcNumber: string
  companyDotNumber: string
  parentUserId?: string
  role: USER_ROLES
  roleName: string
  stateName: USER_STATES
  source: TUserSources
  type: USER_TYPES
  userType: USER_TYPES
  userTypeName: string
  deletedAt?: string
  deletedById?: string
}

export interface IParentUser extends IUserProfileDetails {
  id: string
  cellPhone: string
  email: string
  firstName: string
  lastName: string
  phone: string
  phoneExt: string
  stateName: USER_STATES
}

export interface IUser extends IParentUser, IChildUser {
  confirmed: {
    value: boolean
  }
}

export interface ISearchedUser {
  name: string
  type: 'user' | 'parents'
  cellPhone: string
  email: string
  firstName: string
  id: string
  lastName: string
  phone: string
  phoneExt: string
  stateName: string
}

interface IAssociatedCarrierUser {
  userId: string
  carrierId: string
  carrierName: string
  mcNumber?: string
  dotNumber?: string
}

export interface ISearchedParentUser extends ISearchedUser {
  type: 'parents'
  associatedCarriers: IAssociatedCarrierUser[] // note: i think this should be childUsers
}

export interface IUserCreationState {
  isCreatingUser: boolean
  isSearchingUser: boolean
  searchedUsers?: ISearchedUser[]
  user?: IUser | IChildUser
  userCreateError?: string
  userSearchError?: string
}

export interface IUserCreateStore {
  userCreate: IUserCreationState
}

export interface IUserProfile {
  fetching: boolean
  error: string
  userProfileDetails: IParentUser
  deleting: boolean
  deleteError?: string
  isDriver: boolean
  isOwnerOperator: boolean
  undeleted: {
    id?: string
    loading: boolean
    error: string
    success?: boolean
  }
}

export interface IUserDriverLocations {
  fetching: boolean
  error: string
  driverLocations: IDriverLocation[]
}

export interface IUserRecentShipment {
  id: string
  status: IStatus
  deliveries: INextStop[]
  pickups: INextStop[]
  stops: INextStop[]
  equipment: {
    attributes: {
      [key: string]: string
    }
    icon: string
    name: string
    parentId: string
  }
  info: IShipmentInfo
  users: []
  rates: {
    totalMiles: string
    rateType: RATE_TYPES
    shipperRate?: string
    carrierRate?: string
  }
  trackingStatus: ITrackingStatus
  shipperTrackingSegment: IShipperTrackingSegment
  entityId: string
  entityInitials: string
  entityKey: string
  entityName: string
}

export interface IRecentShipment {
  shipmentList: IUserRecentShipment[]
  error: boolean
  filterOptions: { amGroups: [] }
  firstLoad: boolean
  hasNextPage: boolean
  isFetching: boolean
  params: {
    filters: any
    sortField: string
    sortOrder: string
  }
  shipmentDetails: {}
}

export interface IUserProfileStore {
  userProfile: IUserProfile
  userDriverLocations: IUserDriverLocations
  recentShipments: IRecentShipment
}
